module.exports = __webpack_public_path__ + "img/home-banner-02.efe538ac.jpg";